import { initFlowbite } from 'flowbite';
import $ from 'jquery';
import { getEndCursor, setEndCursor, setHasNextPage } from './state';

$(() => {
  const currentUrl = new URL(window.location.href);
  const $selects = $(
    'select[name="branding"], select[name="colour"], select[name="sort_by"]'
  );
  $selects.each(function () {
    handleSelectChange($(this));
  });
  function handleSelectChange($select) {
    $select.on('change', function () {
      const selectedValue = $(this).val();
      const paramName = $(this).attr('name');

      if (selectedValue) {
        currentUrl.searchParams.set(paramName, selectedValue);
      } else {
        currentUrl.searchParams.delete(paramName);
      }
      history.pushState(null, '', currentUrl.toString());
      getFilterProduct();
    });
  }

  const $inputs = $(
    'input[name="stock"], input[name="priceFrom"], input[name="priceTo"]'
  );
  $inputs.each(function () {
    const $input = $(this);
    const debouncedHandleInputChange = debounce(function () {
      handleInputChange($input);
    }, 1000);

    $input.on('input', debouncedHandleInputChange);
  });
  function handleInputChange($input) {
    const inputValue = $input.val();
    const paramName = $input.attr('name');

    let isValid = true;
    if (paramName === 'stock') {
      if (!/^(0|[1-9]\d*)$/.test(inputValue)) {
        $input.val('');
        currentUrl.searchParams.delete(paramName);
        isValid = false;
      }
    } else if (paramName === 'priceFrom' || paramName === 'priceTo') {
      const priceFrom = parseFloat($('input[name="priceFrom"]').val()) || null;
      const priceTo = parseFloat($('input[name="priceTo"]').val()) || null;
      if (paramName === 'priceFrom') {
        if (
          priceTo !== null &&
          inputValue &&
          parseFloat(inputValue) > priceTo
        ) {
          $input.val('');
          currentUrl.searchParams.delete(paramName);
          isValid = false;
        } else if (inputValue && !/^(0|[1-9]\d*)(\.\d+)?$/.test(inputValue)) {
          $input.val('');
          currentUrl.searchParams.delete(paramName);
          isValid = false;
        }
      } else if (paramName === 'priceTo') {
        if (
          priceFrom !== null &&
          inputValue &&
          parseFloat(inputValue) < priceFrom
        ) {
          $input.val('');
          currentUrl.searchParams.delete(paramName);
          isValid = false;
        } else if (inputValue && !/^(0|[1-9]\d*)(\.\d+)?$/.test(inputValue)) {
          $input.val('');
          currentUrl.searchParams.delete(paramName);
          isValid = false;
        }
      }
    }
    if (isValid && inputValue) {
      currentUrl.searchParams.set(paramName, inputValue);
    } else if (!inputValue) {
      currentUrl.searchParams.delete(paramName);
    }
    history.pushState(null, '', currentUrl.toString());
    getFilterProduct();
  }

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  function getFilterProduct() {
    setEndCursor(null);
    setHasNextPage(false);

    const params = new URLSearchParams(window.location.search);
    const requestData = {
      action: 'load_more_products',
      search: params.get('search') ?? null,
      branding: params.get('branding') ?? null,
      colour: params.get('colour') ?? null,
      stock: params.get('stock') ?? 0,
      priceFrom: params.get('priceFrom') ?? 0,
      priceTo: params.get('priceTo') ?? 0,
      sort_by: params.get('sort_by'),
      term_id: nextPageData.termID,
      endCursor: getEndCursor(),
    };
    $.ajax({
      type: 'GET',
      url: ajax_object.ajax_url,
      data: requestData,
      dataType: 'json',
      beforeSend: () => {
        $('.product-cards-wrapper').addClass('opacity-60');
        $('.filter-product-loading').removeClass('hidden').addClass('flex');
      },
      success: (response) => {
        if (response.success) {
          setEndCursor(response.data.endCursor);
          setHasNextPage(response.data.hasNextPage);
          if (response.data.productsHtml !== '') {
            $('.product-cards-wrapper').html(response.data.productsHtml);
          } else {
            $('.product-cards-wrapper').html(
              '<div class="col-span-6 text-2xl font-bold">Sorry, no results were found.</div>'
            );
          }
          initFlowbite();
        }
      },
      error: (error) => {
        console.error('Error search products: ', error);
      },
      complete: () => {
        $('.product-cards-wrapper').removeClass('opacity-60');
        $('.filter-product-loading').removeClass('flex').addClass('hidden');
      },
    });
  }

  // Mobile collapse or expand filter
  $('.show-filter-options').on('click', function () {
    const content = $('.filter-options');
    content.toggleClass('flex hidden');
  });
});
